<template>
    <div>
        <v-row>
            <v-spacer></v-spacer>
            <img class="stage-image-position" :src="`/finish.png`" />
            <v-spacer></v-spacer>
        </v-row>
        <v-row>
            <v-spacer></v-spacer>
            <span class="display-1 font-weight-medium">{{ stage.name && stage.name.toUpperCase() }}</span>
            <v-spacer></v-spacer>
        </v-row>
        <v-row justify="center">
            <v-col class="col-10 col-md-6">
                <div class="start-content subtitle-1 font-weight-medium">
                    Well done! That's another section done. Before you submit your application, you can always return back to this section from the Dashboard and change any of your answers or review what you've written.
                    
                </div>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" sm="8" md="6">
                <v-row justify="space-around">
                    <div class="back" v-on:click="toDashboard">
                        <span class="body-1">Back to dashboard</span>
                    </div>
                    <div class="next" v-if="stage.next_stage" v-on:click="startStage">
                        <span class="body-1">Progress to {{ nextStageName }}</span>
                    </div>
                </v-row>
            </v-col>
        </v-row>
    </div>
</template>
<script>
// import { stages } from '../db/testdb.js';
// import Client from '../client.js';

export default {
    props: {
        stage_key: String,
        application_id: [String, Number]
    },
    computed: {
        stage() {
            const stages = this.$store.getters['stage/stages'];
            if(stages.length > 0) {
                return stages.find(s => s.key === this.stage_key);
            } else {
                return {};
            }
        },
        nextStageName() {
            const stages = this.$store.getters['stage/stages'];
            const nextStage = stages.find(s => s.key === this.stage.next_stage);
            return nextStage && nextStage.name;
        }
    },
    mounted: async function() {
        // this.$store.dispatch('stage/fetchStages');
        // let client = Client();
        // let res = await client.get(`/stages/${this.stage_key}`);

        // this.stage = res.data;
    },
    methods: {
        startStage: function() {
            console.log(this.stage.next_stage);
            this.$router.push({
                name: "stage.start",
                params: {
                    stage_key: this.stage.next_stage
                }
            })
        },
        toDashboard: function() {
            this.$router.push({ name: 'application.dashboard', params: {
                application_id: this.application_id
            } })
        }
    }
}
</script>
<style lang="scss">
.start-content {
    margin-bottom: 40px;
}

.start-content {
    font-family: $secondary-font !important;
    color: $go-text-grey;
}

.start-content > ul {
    margin-left: 40px;
}

.buttons {
    display: block;
    margin-left: auto;
    margin-right: auto;
}

.next {
    display: inline-block;
    text-decoration: none;
    border: 2px solid $go-dark-grey;
    border-radius: 3px;
    background-color: $go-dark-grey;
    color: white;
    padding: 12px 25px 12px 25px;
    font-family: $secondary-font !important;
    margin-left: 10px;
    margin-bottom: 20px;
}

.back {
    border: 2px solid $go-dark-grey;
    border-radius: 3px;
    display: inline-block;
    text-decoration: none;
    padding: 12px 25px 12px 25px;
    font-family: $secondary-font !important;
    margin-right: 10px;
    margin-bottom: 20px;
}

.back:hover {
    background-color: $go-dark-grey;
    color: white;
    cursor: pointer;
}

.next:hover {
    color: $go-dark-grey;
    cursor: pointer;
    background-color: white;
}
</style>
